import { render } from "./map-data.vue?vue&type=template&id=07bd9b05"
import script from "./map-data.vue?vue&type=script&lang=js"
export * from "./map-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__